import { useEffect } from 'react';
import Suspenseloader from '../splash/suspenseloader';
import { useHistory, useParams } from 'react-router-dom';
import { useAuthContext } from '../../../auth/AuthProvider';
import { useDispatch } from 'react-redux';
import { useRouter } from '../../../shared/hooks';

export function ESNLogin(){

    const params = useParams() as any;
    const dispatch = useDispatch();
    const { handleESNLogin } = useAuthContext();
    const { history } = useRouter();

    useEffect(() => {
        const token = params.token;
        const bidId = params.bidId;
        handleESNLogin(token);
        const redirectURL = `/suppliers/bids/${bidId}/details`;
        if (redirectURL) {
            history.push(redirectURL);
        }
    }, [params, handleESNLogin, history]);

    return <Suspenseloader />;
}
